import { render } from "./ButtonsGroup.vue?vue&type=template&id=19e840aa&bindings={\"file\":\"props\",\"isLocalFile\":\"props\",\"folders\":\"setup\",\"copyCode\":\"setup\",\"forkSnippet\":\"setup\",\"selectedFolder\":\"setup\"}"
import script from "./ButtonsGroup.vue?vue&type=script&lang=js"
export * from "./ButtonsGroup.vue?vue&type=script&lang=js"
script.render = render

export default script